module.exports = __webpack_public_path__ + "img/cow.fd988aed.png";